/**
 * Полифиллы для старых WebView (Android 11 ставит Chrome WebView 90).
 *
 * Внутри приложения «О проекте» — это WebView с нашей же страницей
 * /how-it-works. На Chrome 90 react-markdown@10 звал `Object.hasOwn`
 * (появился в Chrome 93) и страница падала белым экраном: 21 событие в Sentry
 * (JAVASCRIPT-REACT-2, 17.09.2026). Vite собирает под evergreen-браузеры, без
 * @vitejs/plugin-legacy, поэтому такие методы не полифиллятся сами.
 *
 * Импортируется ПЕРВОЙ строкой main.tsx — до React и до остального кода.
 * Реализации эквивалентны спецификации; в современных браузерах файл ничего
 * не делает (все ветки — под проверкой существования).
 */

// Object.hasOwn — Chrome 93 / Safari 15.4
if (typeof (Object as any).hasOwn !== 'function') {
  Object.defineProperty(Object, 'hasOwn', {
    value: (obj: unknown, prop: PropertyKey) =>
      Object.prototype.hasOwnProperty.call(Object(obj), prop),
    configurable: true,
    writable: true,
  })
}

// structuredClone — Chrome 98 / Safari 15.4. Полная семантика (циклы, Map/Set,
// Blob) тут не нужна: в бандле он используется для простых JSON-совместимых
// структур, поэтому безопасный фолбэк — глубокое копирование через JSON.
if (typeof (globalThis as any).structuredClone !== 'function') {
  ;(globalThis as any).structuredClone = <T,>(value: T): T => {
    if (value === null || typeof value !== 'object') return value
    try {
      return JSON.parse(JSON.stringify(value)) as T
    } catch {
      return value
    }
  }
}

// Array.prototype.at / String.prototype.at — Chrome 92
if (typeof (Array.prototype as any).at !== 'function') {
  Object.defineProperty(Array.prototype, 'at', {
    value: function (this: unknown[], n: number) {
      const i = Math.trunc(n) || 0
      return this[i < 0 ? this.length + i : i]
    },
    configurable: true,
    writable: true,
  })
}
if (typeof (String.prototype as any).at !== 'function') {
  Object.defineProperty(String.prototype, 'at', {
    value: function (this: string, n: number) {
      const i = Math.trunc(n) || 0
      return this[i < 0 ? this.length + i : i]
    },
    configurable: true,
    writable: true,
  })
}
